<template>
  <section>
    <form @submit.prevent="compare()">
      <h2 class="text-indigo text-center text-md -mt-6 mb-4">
        Relatórios Salvos
      </h2>

      <div class="flex flex-wrap">
        <div v-for="(side, index) in sides" :key="`${side}-select`" class="pr-6 pb-8 w-1/2">
          <select
            :id="`${side}-report`"
            v-model="form.compared[index]"
            class="form-control form-select"
          >
            <option :value="null" />
            <option v-for="report in reports" :key="report.id" :value="report.id" :class="{ 'hidden': form.compared.includes(report.id) }">{{ report.alias }}</option>
          </select>
        </div>
      </div>

      <div class="text-center">
        <button class="btn-indigo" type="submit">
          Comparar
        </button>
      </div>
    </form>

    <div v-if="table && Object.keys(table).length > 1" class="overflow-x-auto my-8">
      <table class="w-full text-sm text-left text-gray-500">
        <thead class="text-xs text-gray-700 uppercase bg-gray-50">
          <tr>
            <th scope="col" class="py-3 px-6 text-center">
              #
            </th>

            <th v-for="label_index in table._order" :key="`label-${label_index}-${(Math.random() * Math.random())}`" scope="col" class="py-3 px-6 text-center">
              {{ table.labels[label_index] }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(title, index) in titles" :key="title" class="bg-white border-b">
            <td class="py-4 px-6 text-center">
              <strong>{{ title }}</strong>
            </td>

            <td v-for="data_index in table._order" :key="`data-${data_index}-${(Math.random() * Math.random())}`" class="py-4 px-6 text-center">
              {{ table.data[data_index][index] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="chart && Object.keys(chart).length > 1" class="flex w-full">
      <div v-for="(title, index) in titles" :key="title" class="w-1/2">
        <h3 class="text-center text-lg">
          <strong>{{ title }}</strong>
        </h3>

        <multiple-charts class="mx-2" :charts="getCharts(index)" />
      </div>
    </div>

    <div v-if="diagnosis" class="flex w-full">
      <div v-for="(diagnostic, index) in diagnosis" :key="`dds-${index}`" class="w-1/2">
        <set-dti-chart
          v-if="diagnostic"
          class="mx-2"
          :questionnaire="diagnostic['questionnaire']"
          :state="diagnostic['state']"
          :city="diagnostic['city']"
          :labels="diagnostic['labels']"
          :data="diagnostic['data']"
        />
        <set-dti-chart
          v-else
          class="mx-2"
          questionnaire="Sem Questionário"
          state="Sem UF"
          city="Sem Cidade"
          :labels="[]"
          :data="[]"
        />
      </div>
    </div>
  </section>
</template>

<script>
import Layout from '@/Pages/Indicators/Layout'
import MultipleCharts from '@/Indicators/Components/MultipleCharts'
import SetDtiChart from '@/Indicators/Components/SETChart'

export default {
  metaInfo: {
    title: 'Indicadores',
  },
  components: {
    MultipleCharts,
    SetDtiChart,
  },
  layout: Layout,
  props: {
    reports:    Array,
    selected:   Array,
    comparison: Object,
  },
  data() {
    return {
      $this: this,
      form: this.$inertia.form({
        compared: this.selected,
      }),
      get sides() {
        return ['left', 'right']
      },
      get titles() {
        return this.$this.comparison.titles
      },
      get table() {
        return this.$this.comparison.table
      },
      get chart() {
        return this.$this.comparison.chart
      },
      get diagnosis() {
        return this.$this.comparison.diagnosis
      },
      get charts() {
        if (!this.chart) {
          return null
        }

        const charts = []

        this.chart._order.forEach((indicator) => charts.push(this.chart[indicator]))

        return charts
      },
    }
  },
  mounted() {
    // this.$parent.showMenus(false)
  },
  methods: {
    compare() {
      if (this.form.compared.includes(null)) {
        return alert('Escolha dois Relatórios válidos!')
      }

      this.form.post(this.route('indicators.comparison'))
    },
    getCharts(index) {
      const charts = []

      this.charts.forEach((results) => charts.push(results[index]))

      return charts
    },
  },
}
</script>
